"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var GenderType_Factory = /** @class */ (function () {
    function GenderType_Factory() {
    }
    GenderType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            GenderType1: model.GenderType1,
            GenderTypeCode: model.GenderTypeCode,
        };
        return result;
    };
    GenderType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            GenderType1: model.GenderType1,
            GenderTypeCode: model.GenderTypeCode,
        };
        return result;
    };
    return GenderType_Factory;
}());
exports.GenderType_Factory = GenderType_Factory;
